import { render, staticRenderFns } from "./CourseLesson.vue?vue&type=template&id=afb4ac2e&scoped=true&"
import script from "./CourseLesson.vue?vue&type=script&lang=js&"
export * from "./CourseLesson.vue?vue&type=script&lang=js&"
import style0 from "./CourseLesson.vue?vue&type=style&index=0&id=afb4ac2e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afb4ac2e",
  null
  
)

export default component.exports